require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-morocco-covid-19-social-protection-emergency-response.json") })
        }
      }, "path---en-us-project-morocco-covid-19-social-protection-emergency-response");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-morocco-covid-19-social-protection-emergency-response!./.cache/json/en-us-project-morocco-covid-19-social-protection-emergency-response.json
// module id = 545
// module chunks = 231608221292675